import React from 'react';

import {
  MarvinChemicalFormat,
  MARVIN_FORMAT_TO_CHEMICAL_FILE_FORMAT,
} from 'chemistry/marvinjs-wrappers/MarvinJSConstants';
import ChemicalSketcherModal from 'chemistry/molecules/ChemicalSketcherModal';
import {
  chemicalStructureFromFile,
  createChemicalStructureBlob,
} from 'notebook/notes/attachments/molecules/MoleculeUtil';
import {ExternalFile} from 'notebook/util/NoteUtilConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import legacyRunModal from 'ui-library/legacyRunModal';
import {splitExtension} from 'util/FileUtil';
import * as ImportUtil from 'util/ImportUtil';

export interface StructureSketcherToolProps {
  fileType: MarvinChemicalFormat;
  fileName: string;
  externalFile: ExternalFile;
  setNoteLinkedFileFromS3Location: (s3Location: string | undefined) => JQueryPromise<void>;
}

async function handleChemicalEdit(
  fileType: MarvinChemicalFormat,
  fileName: string,
  externalFile: ExternalFile,
  setNoteLinkedFileFromS3Location: (s3Location: string | undefined) => JQueryPromise<void>
): Promise<void> {
  const chemicalFileFormat = MARVIN_FORMAT_TO_CHEMICAL_FILE_FORMAT[fileType];
  const initialSketcherValue = await chemicalStructureFromFile(externalFile, chemicalFileFormat);
  const sketcherModalOutput = await legacyRunModal(ChemicalSketcherModal, {
    initialFilename: splitExtension(fileName).root,
    initialChemicalStructure: initialSketcherValue,
    inputFormat: fileType,
  });
  if (sketcherModalOutput) {
    const chemicalBlob = createChemicalStructureBlob(
      sketcherModalOutput.sketcherValue,
      sketcherModalOutput.filename,
      MARVIN_FORMAT_TO_CHEMICAL_FILE_FORMAT[sketcherModalOutput.saveFormat]
    );
    const file = new File([chemicalBlob], chemicalBlob.name!, {
      type: chemicalBlob.type,
    });
    const s3location = await ImportUtil.upload(file);
    await setNoteLinkedFileFromS3Location(s3location);
  }
}

export default function StructureSketcherTool({
  fileType,
  fileName,
  externalFile,
  setNoteLinkedFileFromS3Location,
}: StructureSketcherToolProps): JSX.Element {
  return (
    <Tooltip key="structure-sketcher" title="Structure sketcher" delay={300}>
      <a
        className="previewCTA hidden-for-print"
        onClick={() => handleChemicalEdit(fileType, fileName, externalFile, setNoteLinkedFileFromS3Location)}
      >
        <BenchlingIcon icon={FolderItemIcon.SmallMolecule} />
      </a>
    </Tooltip>
  );
}
